import React, { useState, useEffect } from "react"
import { Calendar } from "react-date-range"
import { enUS } from "date-fns/locale"
import { Modal } from "components/Modal"
import { dateTimeFormat } from "utils/dateFormatUtils"

export const ExportDateModal = ({
   isOpen,
   onClose = () => {},
   onExport = () => {},
   selectedDate,
   minDate,
   dateFormat = dateTimeFormat.americanFormat,
}) => {
   const [tempDate, setTempDate] = useState(selectedDate || new Date())
   useEffect(() => {
      setTempDate(new Date())
   }, [isOpen])

   const handleCancel = () => {
      setTempDate(selectedDate || new Date())
      onClose()
   }

   const handleExport = () => {
      onExport(tempDate)
      onClose()
   }

   return (
      <Modal
         isOpen={isOpen}
         handleModalToggling={onClose}
         modalTitle="Select Start Date"
         size="md"
         className="export-calender-width"
      >
         <div className="d-flex flex-column align-items-center">
            <div className="  d-flex justify-content-center">
               <Calendar
                  date={tempDate}
                  onChange={date => setTempDate(date)}
                  // minDate={minDate}
                  locale={enUS}
                  dateFormat={dateFormat}
               />
            </div>
            <div className="d-flex justify-content-end mt-3 gap-2 w-100">
               <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={handleCancel}
               >
                  Cancel
               </button>
               <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={handleExport}
               >
                  Done
               </button>
            </div>
         </div>
      </Modal>
   )
}

export default ExportDateModal
